export default class Cookies {
  static getCookie(name) {
    let cookies = document.cookie;
    if (!cookies) {
      return false;
    }
    // eslint-disable-next-line no-shadow
    cookies = cookies.split(';').reduce((cookies, cookie) => {
      // eslint-disable-next-line no-shadow
      const name = cookie.substring(0, cookie.indexOf('=')).trim();
      const value = cookie.substring(cookie.indexOf('=') + 1, cookie.length).trim();
      // eslint-disable-next-line no-param-reassign
      cookies[name] = value;
      return cookies;
    }, {});

    if (name) {
      // eslint-disable-next-line no-prototype-builtins
      return cookies.hasOwnProperty(name) ? cookies[name] : false;
    }

    return cookies;

  }

  static setCookie(name, data, expires) {
    let value = '';
    if (typeof data === 'object') {
      value = '';
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const field in data) {
        value += `&${field}=${data[field]}`;
      }
      value = encodeURI(value.slice(1));
    } else {
      value = data;
    }
    document.cookie = `${name  }=${  value  };path=/;expires=${  expires.toGMTString()  };domain=${  window.location.hostname}`;
  }
}
